module.exports = __webpack_public_path__ + "media/เฮ้อไอ้เหี้ย.c90a4fba.mp3";